import { ReactTab } from 'crux';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { isEmpty } from 'lodash';
import { PlanDetailsWrapper, PlanHeading, PlanTitle, PlanPremium, PlanTerm } from './styles';
import { updateAnswersArray } from '../../../redux/actions';
import { getUTCTimestamp, scrollQuestionIntoView } from '../../../utils';
import { updateQuestionAnswerTimeStamp } from '../../../redux/actions/questions';
import { getTimeStampData } from '../../../cruxComponents/utils';

const themeConfig = {
  tab: {
    bgColor: '#E6E8EA',
    color: '#262D3F',
    fontSize: '18px',
    outline: '4px solid #037BB5',
  },
  grid: {
    color: '#262D3F',
    bgColor: '#E6E8EA',
    selectedBgColor: '#18355E',
    outline: '4px solid #037BB5',
    outlineOffset: '1px',
    fontSize: '18px',
  },
  selectionText: {
    color: '#262d3f',
  },
};

const Tabs = ({
  question,
  handleChange,
  lastFocusedElementId,
  theme,
  screenViewport,
  updateTimeStamp,
  meta,
}) => {
  const {
    question_json_data: { tabs = [], 'default-tab': defaultTab = 0 },
    response = {},
    transaction_log: transactionLog,
  } = question;
  const timeStampRef = useRef(null);

  // Tab Navigation to preserve focus on grid cell
  React.useEffect(() => {
    const gridCellEl = document.getElementById(lastFocusedElementId);
    if (
      lastFocusedElementId &&
      lastFocusedElementId.startsWith('grid-cell-row') &&
      gridCellEl &&
      typeof gridCellEl.focus === 'function'
    ) {
      gridCellEl.focus();
    }
  }, []);

  const onChange = (currentSelection) => {
    if (isEmpty(currentSelection)) {
      handleChange('');
      return;
    }
    if (currentSelection.noPlans) {
      if (isEmpty(response)) handleChange('');
      return;
    }
    const { tab, col, row, gridCellId } = currentSelection;
    const category = tabs[tab].title;
    const name = tabs[tab].data[row][0].content;
    const amount = tabs[tab].data[row][col].content;
    const duration = tabs[tab].header[col].heading;
    handleChange({ name, amount, duration, category }, gridCellId);
  };

  const handleFocus = (e) => {
    timeStampRef.current.timeStart = getUTCTimestamp();
    scrollQuestionIntoView({
      element: e.target,
      screenViewport,
      theme,
    });
    updateTimeStamp(getTimeStampData(timeStampRef, transactionLog, meta));
  };

  return (
    <div id={ question.question_id }>
      <div>
        <ReactTab
          tabs={ tabs }
          defaultTab={ defaultTab }
          ref={ timeStampRef }
          onChange={ onChange }
          themeConfiguration={ themeConfig }
          onTabFocus={ handleFocus }
          onCellFocus={ handleFocus }
        />
      </div>
      {!response.noPlans && (
        <PlanDetailsWrapper ref={ timeStampRef }>
          <PlanHeading>Current Selection:</PlanHeading>
          {!isEmpty(response) && (
            <>
              <PlanTitle>{response.name}</PlanTitle>
              <PlanPremium>
                {response.amount}
                <PlanTerm>({response.duration})</PlanTerm>
              </PlanPremium>
            </>
          )}
        </PlanDetailsWrapper>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    lastFocusedElementId: state.questions.lastFocusedElementId,
    screenViewport: state.meta.screenViewport,
    meta: state.meta,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const {
    question: { question_id: questionId },
    sectionIndex,
  } = props;

  return {
    handleChange: (response, gridCellId) => {
      dispatch(
        updateAnswersArray({
          response,
          questionId,
          sectionIndex,
          gridCellId,
        }),
      );
    },
    updateTimeStamp: (timeStampData, isPrefilled = false) => {
      dispatch(
        updateQuestionAnswerTimeStamp(questionId, timeStampData, props.sectionIndex, isPrefilled),
      );
    },
  };
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(Tabs));
